if (!customElements.get('voo-localization-form')) {
  customElements.define(
    'voo-localization-form',
    class VooLocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          openModalBtns: document.querySelectorAll('.voo-localization-wrapper'),
          openDropdownBtns: this.querySelectorAll('.voo-localization-form__dropdown-button'),
          modalCloseBtn: this.querySelector('.voo-localization-modal__form-close'),
          cancelBtn: this.querySelector('#localizationCancel'),
          modalContainer: this.querySelector('.voo-localization-modal__form'),
          inputCurrency: this.querySelector('input[name="currency_code"]'),
          search: this.querySelector('#voo-country-filter-input'),
        };

        if (this.elements.openModalBtns.length > 0) {
          this.elements.openModalBtns.forEach((btn) => {
            btn.addEventListener('click', this.openModal.bind(this));
          });
        }

        if (this.elements.openDropdownBtns.length > 0) {
          this.elements.openDropdownBtns.forEach((btn) => {
            btn.addEventListener('click', this.openDropdown.bind(this));

            this.addEventListener('click', (e) => {
              const withinBoundaries = e.composedPath().includes(btn);

              if (!withinBoundaries && !e.target.classList.contains('voo-localization-form__dropdown-search')) {
                this.closeDropdown.bind(this)(btn);
              }
            });
          });
        }

        if (this.elements.modalCloseBtn) {
          this.elements.modalCloseBtn.addEventListener('click', this.closeModal.bind(this));
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
        }

        if (this.elements.cancelBtn) {
          this.elements.cancelBtn.addEventListener('click', this.resetValues.bind(this));
        }

        if (this.elements.modalContainer) {
          this.addEventListener('click', (e) => {
            const withinBoundaries = e.composedPath().includes(this.elements.modalContainer);

            if (!withinBoundaries) {
              this.closeModal.bind(this)();
            }
          });

          if (this.elements.inputCurrency) {
            this.changeToCurrentCurrency.bind(this)(this.elements.inputCurrency);
          }
        }

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.querySelector('#localizationSave').addEventListener('click', this.onSubmitClick.bind(this));
        this.querySelectorAll('.voo-dropdown-list__item-link').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this))
        });
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.elements.openDropdownBtns.forEach((btn) => {
          if (btn.closest('.voo-localization-form__dropdown')?.classList.contains('open')) {
            this.closeDropdown.bind(this)(btn);
          }
        });
      }

      openModal() {
        document.documentElement.classList.add('overflow-hidden');
        this.style.visibility = 'visible';
        this.classList.add('active');
      }

      closeModal() {
        document.documentElement.classList.remove('overflow-hidden');
        this.style.visibility = 'hidden';
        this.classList.remove('active');
        if (this.elements.search) this.resetFilter.bind(this)();
      }

      changeToCurrentCurrency(element) {
        const currencyDropdown = element.closest('.voo-localization-form__dropdown-wrapper');
        if (!currencyDropdown || (!this.getCookie('voo_currency') && !localStorage.getItem('voo_currency'))) return;

        const currencyButtonText = currencyDropdown.querySelector('.voo-localization-form__dropdown-text');
        const currencyDropdownList = currencyDropdown.querySelectorAll('.voo-dropdown-list__item');
        if (!currencyButtonText || currencyDropdownList.length < 2) return;

        const currentCurrency = this.getCookie('voo_currency') || localStorage.getItem('voo_currency');

        currencyDropdownList.forEach((item) => {
          if (item.dataset.value === currentCurrency) {
            const vooCurrencyEls = document.querySelectorAll('.voo-localization__currency');
            item.classList.add('voo-dropdown-list__item--current');
            currencyButtonText.textContent = item.dataset.name;
            this.elements.inputCurrency.value = currentCurrency;
            this.elements.inputCurrency.dataset.currentValue = currentCurrency;
            this.elements.inputCurrency.dataset.currentName = item.dataset.name;

            if (vooCurrencyEls.length !== 0) {
              vooCurrencyEls.forEach((element) => {
                element.textContent = currentCurrency;
              });
            }
          } else if (item.classList.contains('voo-dropdown-list__item--current')) {
            item.classList.remove('voo-dropdown-list__item--current');
          }
        });
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const allCountries = this.querySelectorAll('.voo-localization-modal__country-wrapper .voo-dropdown-list__item-link');
        let visibleCountries = allCountries.length;

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        this.querySelector('.voo-localization-modal__country-wrapper .voo-localization-form__dropdown-list').scrollTop = 0;
      }

      resetValues() {
        const inputForms = this.querySelectorAll('.form-input');
        if (inputForms.length === 0) return;

        inputForms.forEach((input) => {
          input.value = input.dataset.currentValue;
          const wrapper = input.closest('.voo-localization-form__dropdown-wrapper');
          const buttonText = wrapper?.querySelector('.voo-localization-form__dropdown-text');
          const dropdownList = wrapper?.querySelectorAll('.voo-dropdown-list__item');
          if (!buttonText || dropdownList.length === 0) return;

          buttonText.textContent = input.dataset.currentName;

          dropdownList.forEach((item) => {
            if (input.dataset.currentName === item.dataset.name) {
              item.classList.add('voo-dropdown-list__item--current');
            } else if (item.classList.contains('voo-dropdown-list__item--current')) {
              item.classList.remove('voo-dropdown-list__item--current');
            }
          });
        });
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      resetFilter() {
        this.elements.search.value = '';
        this.filterCountries();
      }

      onItemClick(event) {
        event.preventDefault();
        const dropdownWrapper = event.target.closest('.voo-localization-form__dropdown-wrapper');
        const currentItem = event.target.closest('.voo-dropdown-list__item');
        if (!dropdownWrapper || !currentItem) return;

        const input = dropdownWrapper.querySelector('.form-input');
        const dropdownText = dropdownWrapper.querySelector('.voo-localization-form__dropdown-text');
        const items = dropdownWrapper.querySelectorAll('.voo-dropdown-list__item');
        if (!input || !dropdownText || items.length === 0) return;

        input.value = event.currentTarget.dataset.value;
        dropdownText.textContent = event.currentTarget.dataset.name;

        items.forEach((item) => {
          if (item.classList.contains('voo-dropdown-list__item--current')) {
            item.classList.remove('voo-dropdown-list__item--current')
          }
        });

        if (this.elements.search) this.resetFilter.bind(this)();

        currentItem.classList.add('voo-dropdown-list__item--current');

        if(event.currentTarget.hasAttribute('data-country')) {
          this.changeLanguage.bind(this)(event.currentTarget.dataset.value, event.currentTarget.hasAttribute('data-european'));
          this.changeCurrency.bind(this)(event.currentTarget.hasAttribute('data-european'), event.currentTarget.hasAttribute('data-american'));
        }
        if(event.currentTarget.hasAttribute('data-language')) {
          this.changeCountry.bind(this)(event.currentTarget.dataset.countryCode);
        };
      }

      changeLanguage(iso_code, european) {
        const languageWrapper = this.querySelector('.voo-localization-modal__language-wrapper');
        if (!languageWrapper) return;

        const languageInput = languageWrapper.querySelector('.form-input');
        const buttonText = languageWrapper.querySelector('.voo-localization-form__dropdown-text');
        const itemLinkList = languageWrapper.querySelectorAll('.voo-dropdown-list__item-link');
        if (!languageInput || !buttonText || itemLinkList.length === 0) return;

        let new_iso_code = iso_code;
        if (!european) {
          new_iso_code = 'EN';
        }

        itemLinkList.forEach((item) => {
          this.selectAnotherOption(item, languageInput, buttonText, item.dataset.countryCode.includes(new_iso_code));
        });
      }

      changeCurrency(european, american) {
        const currencyWrapper = this.querySelector('.voo-localization-modal__currency-wrapper');
        if (!currencyWrapper) return;

        const currencyInput = currencyWrapper.querySelector('.form-input');
        const buttonText = currencyWrapper.querySelector('.voo-localization-form__dropdown-text');
        const itemLinkList = currencyWrapper.querySelectorAll('.voo-dropdown-list__item-link');
        if (!currencyInput || !buttonText || itemLinkList.length === 0) return;

        let new_iso_code = 'gbp';
        if (european) {
          new_iso_code = 'eur';
        } else if (american) {
          new_iso_code = 'usd';
        }

        itemLinkList.forEach((item) => {
          this.selectAnotherOption(item, currencyInput, buttonText, item.dataset.value === new_iso_code);
        });
      }

      changeCountry(iso_codes) {
        const iso_code = iso_codes.split('|')[0];
        const countryWrapper = this.querySelector('.voo-localization-modal__country-wrapper');
        if (!countryWrapper) return;

        const countryInput = countryWrapper.querySelector('.form-input');
        const countrySelectElement = countryWrapper.querySelector('.voo-dropdown-list__item--current .voo-dropdown-list__item-link');
        const buttonText = countryWrapper.querySelector('.voo-localization-form__dropdown-text');
        const itemLinkList = countryWrapper.querySelectorAll('.voo-dropdown-list__item-link');
        if (!countryInput || countrySelectElement?.hasAttribute('data-european') || !buttonText || itemLinkList.length === 0) return;

        if (!countrySelectElement?.hasAttribute('data-european')) {
          this.changeCurrency.bind(this)(iso_code !== 'EN', countrySelectElement?.hasAttribute('data-american'));
        }

        itemLinkList.forEach((item) => {
          this.selectAnotherOption(item, countryInput, buttonText, iso_code === item.dataset.value);
        });
      }

      selectAnotherOption(item, input, button, condition) {
        const itemWrapper = item.closest('.voo-dropdown-list__item');
        if (!itemWrapper) return;

        if (condition) {
          input.value = item.dataset.value;
          button.textContent = item.dataset.name;
          itemWrapper.classList.add('voo-dropdown-list__item--current');
        } else if (itemWrapper.classList.contains('voo-dropdown-list__item--current')) {
          itemWrapper.classList.remove('voo-dropdown-list__item--current');
        }
      }

      openDropdown(event) {
        if (
          event.target.classList.contains('voo-localization-form__dropdown-arrow') ||
          event.target.closest('.voo-localization-form__dropdown-arrow') &&
          event.target.closest('.voo-localization-form__dropdown').classList.contains('open')
        ) {
          this.closeDropdown(event.currentTarget);
        } else {
          event.currentTarget.closest('.voo-localization-form__dropdown')?.classList.add('open');
          event.currentTarget.querySelector('.voo-localization-form__dropdown-search')?.focus();
        }
      }

      closeDropdown(currentDropdown) {
        const dropdownWrapper = currentDropdown.closest('.voo-localization-form__dropdown');

        if (dropdownWrapper && dropdownWrapper.classList.contains('open')) {
          dropdownWrapper.classList.remove('open');
          if (this.elements.search) this.resetFilter.bind(this)();
        }
      }

      setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      }

      getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
      }

      onSubmitClick(event) {

        event.preventDefault();
        
        if (this.elements.inputCurrency) {
          const currentCurrency = this.getCookie('voo_currency') || localStorage.getItem('voo_currency');

          if (currentCurrency !== this.elements.inputCurrency.value) {
            this.setCookie('voo_currency', this.elements.inputCurrency.value);
            localStorage.setItem('voo_currency', this.elements.inputCurrency.value);
          }
        }

        const localeInput = this.querySelector('input[name="locale_code"]');
        const selectedLocale = localeInput ? localeInput.value : null;
        
        if (selectedLocale) {
          const hreflangLink = document.querySelector(`link[rel="alternate"][hreflang="${selectedLocale}"]`);
          
          if (hreflangLink && hreflangLink.href && hreflangLink.href !== window.location.href) {
            this.closeModal();
            
            window.location.href = hreflangLink.href;
            return;
          }
        }
        
        const form = event.target.closest('form');
        if (form) {
          this.closeModal();
          form.submit();
        }
      }

    }
  );
}
